import React, { Component } from 'react';

// value="Bradly Dalzine - CFAA # 19-998112"

class Step3 extends Component {
    render() {
        return (
            <div className="card card-body">
                <div className="form-group">
                    <label htmlFor="text">1. This is to certify that the monitored system has been tested and inspected in accordance with CAN/ULC-S561, Standard for Installation and Services for Fire Signal Receiving Centres and Systems, Section 12, Periodic Inspections and Tests, and these records document the results of testing performed.</label>
                </div>
                <div className="form-group">
                    <label htmlFor="fullyFunctional">2. The monitored system is fully functional:</label>
                    <div>
                        <select id="fullyFunctional" name="fullyFunctional" className="custom-select" required="required">
                            <option value="YES">YES</option>
                            <option value="NO">NO</option>
                        </select>
                    </div>
                </div >
                <div className="form-group">
                    <label htmlFor="deficiencies">3. The monitored system has deficiencies noted on the page attached:</label>
                    <div>
                        <select id="deficiencies" name="deficiencies" required="required" className="custom-select">
                            <option value="NO">NO</option>
                            <option value="YES">YES</option>
                        </select>
                    </div>
                </div >
                <div className="form-group">
                    <label htmlFor="deficienciesComments">4. Comments</label>
                    <textarea id="deficienciesComments" name="deficienciesComments" cols="40" rows="5" className="form-control"></textarea>
                </div >
                <div className="form-group">
                    <label htmlFor="copyOwner">5. A copy of this report will be given to the owner or representative for this building.</label>
                    <input id="copyOwner" name="copyOwner" type="text" required="required" className="form-control here" />
                </div >
                <div className="form-group">
                    <label htmlFor="techName">Name of Service Personnel Conducting Test</label>
                    <input id="techName" name="techName" type="text" required="required" className="form-control here" />
                </div >
                <div className="form-group">
                    <label htmlFor="techPhone">Phone Number of Service Personnel Conducting Test</label>
                    <div className="input-group">
                        <input id="techPhone" name="techPhone" type="text" required="required" className="form-control here" />
                    </div>
                </div >
            </div >
        );
    }
}

export default Step3;



// WEBPACK FOOTER //
// ./src/components/Step3.js